import { Message } from 'src/app/models/message';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ScatterPeriod } from 'src/app/models/obs/scatterPeriod';
import { Tematic } from 'src/app/models/obs/tematic';
import { Tier3 } from 'src/app/models/obs/tier3';
import { ScatterPeriodService } from 'src/app/services/obs/scatter-period.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';
import { ActivatedRoute } from '@angular/router';
import { ScatterPointsService } from 'src/app/services/obs/scatter-points.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ScatterPoint } from 'src/app/models/obs/scatterPoint';
import { AdmScatterComponent } from '../adm-scatter/adm-scatter.component';
import { AdmModalScatterPeriodComponent } from '../adm-modal-scatter-period/adm-modal-scatter-period.component';

@Component({
  selector: 'app-adm-form-scatter-graph',
  templateUrl: './adm-form-scatter-graph.component.html',
  styleUrl: './adm-form-scatter-graph.component.scss'
})
export class AdmFormScatterGraphComponent implements OnInit {

  msg: Message;
  tem: Tematic[];
  t3: Tier3[];
  dpto: string = 'Perú';
  band: string;
  idt2: number;
  isSelected: boolean = false;
  /*   csv2019 = "assets/csv/risk.csv"; */
  dx1: number = 0; //  Dominio del gráfico
  dx2: number = 0; // Dominio del gráfico
  dy1: number = 0; //  Dominio del gráfico
  dy2: number = 0; // Dominio del gráfico

  scatterperiod: ScatterPeriod[] = [];
  scatterpoint: any[];
  idTier1: string;
  form: FormGroup;
  selectedDate: string | null = null;
  originalSelectedDate: string | null = null;
  edit: boolean = false;

  latestPeriodData: any; // Declara una variable para almacenar los datos del periodo más reciente
  selectedPeriod: any | null = null;


  showModal = false;
  @ViewChild(AdmScatterComponent, { static: false }) scatterComponent: AdmScatterComponent;
  @ViewChild(AdmModalScatterPeriodComponent, { static: false }) scatterModalComponent: AdmModalScatterPeriodComponent;

  initialFormValues: any

  constructor(
    private fb: FormBuilder,
    private t3S: Tier3Service,
    private scatterpointS: ScatterPointsService,
    private scatterperiodS: ScatterPeriodService,
    private tematicService: TematicService,
    private errorService: ErrorHandlingService,
    private activedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.createForm();
    this.originalSelectedDate = this.selectedDate;
    const params = this.activedRoute.snapshot.params;
    this.idTier1 = params['id'];
    this.isRiskOrOpp();
    this.getTematic();
    this.getAllScatterPeriod();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idtier3: [null, [Validators.required, Validators.min(1)]],
      probabilidad: [0, [Validators.required, Validators.min(1), Validators.max(5)]],
      impacto: [0, [Validators.required, Validators.min(1), Validators.max(5)]],
      mp: [0],
      mi: [0],
      mtx: [0],
      mty: [0],
      status: [true]
    });
    this.initialFormValues = this.form.value;
  }

  isRiskOrOpp() {
    this.band = this.idTier1 == '6' ? 'risk' : 'opp';
  }

  openModal() {
    this.showModal = true;
    this.scatterModalComponent.ngOnInit();
  }

  onModalClose() {
    this.showModal = false;
  }

  onModalSave() {
    this.getAllScatterPeriod();
  }
  /* ------------------------------------------------------------------------------------------------- */
  handlePuntoSeleccionado(dataDelPunto: any) {
    const tier3Selected = this.t3.find(t => t.code === dataDelPunto.codigo);
    if (tier3Selected) {
      this.form.patchValue({
        id: dataDelPunto.id,
        idtier3: tier3Selected.id,
        probabilidad: dataDelPunto.probabilidad,
        impacto: dataDelPunto.impacto,
        mp: dataDelPunto.mp,
        mi: dataDelPunto.mi,
        mtx: dataDelPunto.mtx,
        mty: dataDelPunto.mty
      });
      this.edit = true;
    }
  }


  save() {
    if (this.form.valid) {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    }
  }


  create(sp: ScatterPoint) {
    delete sp.id;
    this.scatterpointS.create(sp).subscribe(
      res => {
        this.form.patchValue({ id: res.id });
        this.addPointToArray();
        this.afterSaveOrUpdate();
      },
      err => { }
    )
  }

  update(id: string, sp: ScatterPoint) {
    this.scatterpointS.update(id, sp).subscribe(
      res => { this.addPointToArray(); this.afterSaveOrUpdate(); },
      err => { }
    )
  }
  addPointToArray() {
    const formValues = this.form.value;
    const existingPointIndex = this.scatterpoint.findIndex(sp => sp.id === formValues.id);

    if (existingPointIndex !== -1) {
      // Si ya existe un punto con la misma ID, actualiza los campos modificados
      const existingPoint = this.scatterpoint[existingPointIndex];
      existingPoint.probabilidad = formValues.probabilidad;
      existingPoint.impacto = formValues.impacto;
      existingPoint.mp = formValues.mp;
      existingPoint.mi = formValues.mi;
      existingPoint.mtx = formValues.mtx;
      existingPoint.mty = formValues.mty;
    } else {
      // Si no existe un punto con la misma ID, agrega uno nuevo      
      const tier3Selected = this.t3.find(t => t.id === formValues.idtier3);
      const tematicSelected = this.tem.find(tem => tem.id === tier3Selected.idtematic);
      const newPoint: any = {
        id: formValues.id,
        idtier3: formValues.idtier3,
        etiqueta: tier3Selected.shorttitle,
        codigo: tier3Selected.code,
        color: tematicSelected.color,
        probabilidad: formValues.probabilidad,
        impacto: formValues.impacto,
        mp: formValues.mp,
        mi: formValues.mi,
        mtx: formValues.mtx,
        mty: formValues.mty,
        status: formValues.status
      };
      this.scatterpoint.push(newPoint);
    }
    this.scatterComponent.drawMap(this.scatterpoint);
  }

  onDateSelected(selectedDate: any) {
    this.selectedPeriod = selectedDate;
    if (selectedDate) {
      const updatedYearBD = this.calculateUpdatedYear(selectedDate['period']);
      this.dx1 = selectedDate['xi'];
      this.dx2 = selectedDate['xf'];
      this.dy1 = selectedDate['yi'];
      this.dy2 = selectedDate['yf'];
      this.getByT1AndYear(this.idTier1, updatedYearBD);
      this.getByYear(this.idTier1, updatedYearBD);
    }
  }

  getAllScatterPeriod() {
    this.scatterperiodS.getAllByIdT1(this.idTier1).subscribe({
      next: res => {
        this.scatterperiod = res['data']
        const latestPeriod = this.findLatestPeriod(this.scatterperiod);
        if (latestPeriod) {
          this.latestPeriodData = latestPeriod;
          this.selectedDate = this.latestPeriodData;
          this.onDateSelected(this.latestPeriodData)
        }
      },
      error: err => { }
    })
  }

  getTematic() {
    this.tematicService.getAll().subscribe({
      next: ({ data }: any) => { this.tem = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  getByYear(idTier1: string, year: string) {
    this.t3 = [];
    this.t3S.getByYear(idTier1, year).subscribe({
      next: ({ data }: any) => { this.t3 = data; },
      error: (err) => { this.msg = this.errorService.handleError(err); }
    });
  }

  getByT1AndYear(idTier1: string, year: string) {
    this.scatterpoint = [];
    this.scatterpointS.getAllByIdTier1AndYear(idTier1, year).subscribe({
      next: ({ data }: any) => { this.scatterpoint = data; },
      error: (err) => { this.msg = this.errorService.handleError(err); }
    });
  }

  //Este lo usamos para calcular el periodo de recojo e informacion y mostrar el periodo de publicacion
  calculateUpdatedYear(period: string): string {
    const year = parseInt(period, 10);
    const updatedYear = year - 1;
    const updatedYearBD = updatedYear.toString();
    return updatedYearBD;
  }

  //Este lo usaremos para obtener el periodo mas reciente y desde aca partimos con la inf de los demas componentes
  findLatestPeriod(periods: any[]): any {
    let latestPeriod = null;
    let latestYear = 0;

    for (const period of periods) {
      const year = parseInt(period['period']);
      if (year > latestYear) {
        latestYear = year;
        latestPeriod = period;
      }
    }

    return latestPeriod;
  }

  afterSaveOrUpdate() {
    this.form.setValue(this.initialFormValues);
    this.form.markAsPristine();
    this.form.markAsUntouched();
    this.edit = false;
  }

  resetSettingValues() {
    this.form.patchValue({
      mp: 0,
      mi: 0,
      mtx: 0,
      mty: 0
    });
    this.edit = true;
  }

  cancel() {
    this.afterSaveOrUpdate();
  }

  Tier3Selected(selectedT3Code: string): boolean {
    return this.scatterpoint.some(sp => sp.codigo === selectedT3Code);
  }


  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  getCancelarRouterLink(): string[] {
    if (this.idTier1 === '6') {
      return ['/adm/riesgo/list'];
    } else {
      return ['/adm/oportunidad/list'];
    }
  }

}
